<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="9">
        <h1 class="text-h4 mb-2">Detail Pengguna</h1>
        <div class="body-1 text--secondary">
          Informasi detail, seperti nama dan foto, data yang dikumpulkan
          pengguna
        </div>
      </v-col>
    </v-row>
    <v-row justify="center" class="my-4">
      <v-col cols="12" md="3">
        <v-card outlined>
          <v-card-text>
            <v-avatar
              class="d-block mx-auto"
              :color="account.accountAvatar ? 'white' : 'grey lighten-2'"
              width="144"
              height="144"
            >
              <v-img :src="account.accountAvatar" :alt="account.accountName" />
            </v-avatar>
            <h3 class="body-1 font-weight-bold text-center mt-4 mb-1">
              {{ account.accountName }}
            </h3>
            <p class="ma-0 caption text-center">
              {{ account.accountPosition }}
            </p>
            <!-- <div class="text-center">
              <v-btn
                v-if="account.accountId"
                class="mt-2"
                :to="{ name: 'Call', params: { uid: account.accountId } }"
                small
                color="success"
              >
                <v-icon left>
                  mdi-phone
                </v-icon>
                Call
              </v-btn>
            </div> -->
            <v-divider class="my-3" />
            <v-row dense>
              <v-col>
                <v-list-item-title
                  class="body-2 grey--text text--darken-2 mt-2"
                >
                  <p class="caption grey--text text-lighten-4 mb-1">
                    NRP/NIK
                  </p>
                  {{ account.accountCode || '-' }}
                </v-list-item-title>
              </v-col>
              <v-col>
                <v-list-item-title
                  class="body-2 grey--text text--darken-2 mt-2"
                >
                  <p class="caption grey--text text-lighten-4 mb-1">
                    Role
                  </p>
                  {{ account.accountGroupName || '-' }}
                </v-list-item-title>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-list-item-title
                  class="body-2 grey--text text--darken-2 mt-2"
                >
                  <p class="caption grey--text text-lighten-4 mb-1">
                    No Telepon
                  </p>
                  {{ account.accountMobilephone || '-' }}
                </v-list-item-title>
              </v-col>
              <v-col>
                <v-list-item-title
                  class="body-2 grey--text text--darken-2 mt-2"
                >
                  <p class="caption grey--text text-lighten-4 mb-1">
                    Email
                  </p>
                  {{ account.accountEmail || '-' }}
                </v-list-item-title>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-list-item-title
                  class="body-2 grey--text text--darken-2 mt-2"
                >
                  <p class="caption grey--text text-lighten-4 mb-1">
                    Wilayah
                  </p>
                  {{ account.unitSubdistrictName || '-' }}
                </v-list-item-title>
              </v-col>
              <v-col>
                <v-list-item-title
                  class="body-2 grey--text text--darken-2 mt-2"
                >
                  <p class="caption grey--text text-lighten-4 mb-1">
                    Status
                  </p>
                  <span
                    :class="
                      account.accountIsActive * 1 ? 'green--text' : 'red--text'
                    "
                    class="transparent"
                  >
                    {{ account.accountIsActive * 1 ? 'Aktif' : 'Non-Aktif' }}
                  </span>
                </v-list-item-title>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-list-item-title
                  class="body-2 grey--text text--darken-2 mt-2"
                >
                  <p class="caption grey--text text-lighten-4 mb-1">
                    Unit
                  </p>
                  {{ account.unitName || '-' }}
                </v-list-item-title>
              </v-col>
            </v-row>
            <v-row
              dense
              v-if="
                account.accountPosition !== 'Babinsa' &&
                  account.accountPosition !== 'Satgas Desa'
              "
            >
              <v-col>
                <v-list-item-title
                  class="body-2 grey--text text--darken-2 mt-2"
                >
                  <p class="caption grey--text text-lighten-4 mb-1">
                    RW/Rt
                  </p>
                  {{ account.accountUnitName || '-' }}
                </v-list-item-title>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-list-item-title
                  class="body-2 grey--text text--darken-2 mt-2"
                >
                  <p class="caption grey--text text-lighten-4 mb-1">
                    Terakhir Login
                  </p>
                  <template v-if="account.accountLastLogin">
                    {{ account.accountLastLogin | datetime }}
                  </template>
                  <template v-if="!account.accountLastLogin">
                    -
                  </template>
                </v-list-item-title>
              </v-col>
              <v-col>
                <v-list-item-title
                  class="body-2 grey--text text--darken-2 mt-2"
                >
                  <p class="caption grey--text text-lighten-4 mb-1">
                    Terakhir Update lokasi
                  </p>
                  <template v-if="account.accountLastLocationDatetime">
                    {{ account.accountLastLocationDatetime | datetime }}
                  </template>
                  <template v-if="!account.accountLastLocationDatetime">
                    -
                  </template>
                </v-list-item-title>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card outlined>
          <v-tabs class="custom-tabs" color="light-green">
            <v-tab :to="{ name: 'user-laporan' }" exact class="text-capitalize">
              Laporan
            </v-tab>
          </v-tabs>
          <router-view />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import account from '@/mixins/account';
export default {
  mixins: [account],
  created() {
    this.getAccount(this.$route.params.id);
  }
};
</script>
